// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__eZwZS","skeleton-loading":"Skeleton_skeleton-loading__noIeG"};